import { formatAge } from '../utils/formatAge';

type CustomTickProps = {
  x: number;
  y: number;
  payload: any;
  isFirst: boolean;
};

export default function CustomTick({
  x,
  y,
  payload,
  isFirst,
}: CustomTickProps) {
  return (
    <text
      x={x}
      y={y + 2}
      textAnchor={isFirst ? 'start' : 'middle'} // Align first tick to the start
      fill='#666'
      fontSize='11px'
    >
      {formatAge(payload.value)}
    </text>
  );
}
